<template>
  <el-dialog
    v-drag
    title="查看附件"
    :visible.sync="dialogVisible"
    width="800px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <BaseTable :tableData="tableData" :height="400" :isPager="false">
        <div slot="opt" slot-scope="row" class="optbtn">
          <div title="查看" class="btn" @click="check(row.scope)">
            <i class="el-icon-zoom-in"></i>
          </div>
          <div title="下载" class="btn" @click="download(row.scope)">
            <img src="@/assets/images/bill/download.png" alt="" />
          </div>
        </div>
      </BaseTable>
    </div>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { fileList } from '@/api/system'
export default {
  components: {
    BaseTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      operateId: '',
      tableData: {
        fileds: [
          {
            filed: 'fileName',
            label: '文件名',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '150px',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      }
    }
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getFileList()
      }
    }
  },
  methods: {
    async getFileList() {
      try {
        const res = await fileList({ id: this.rowData.id })
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    check(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      )
      const { guid } = item
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        // window.open(
        //   `/api/SystemFile/preview?guid=${fileGuid}`
        // )
        this.$viewerApi({
          images: [`/api/SystemFile/preview?guid=${guid}`]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(`/api/SystemFile/preview?guid=${guid}`)
      } else {
        this.$message('暂时只支持图片和PDF查看')
      }
    },
    download(v) {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = `/api/SystemFile/downLoadFile?guid=${v.guid}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: auto;

  .optbtn {
    display: flex;
    justify-content: space-around;
  }
  .btn {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    cursor: pointer;
    img {
      margin-right: 4px;
    }
    i {
      font-size: 18px;
      margin-right: 4px;
    }
  }
}
</style>
